// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"Drawer_dialogContent__1_Id_","slideIn":"Drawer_slideIn__zI7S6","slideOut":"Drawer_slideOut__oKRWV"};